/* RAYZ welcome: apply the first-order code to the session, then reveal it as a sealed note. */
(function () {
  const box = document.getElementById('RayzWelcome');
  if (!box) return;
  const pill = document.getElementById('RayzWelcomePill');
  const html = document.documentElement;
  const code = box.dataset.code;
  const KEY = 'rz-welcome';
  let state = {}; try { state = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) {}
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} };
  const note = () => document.querySelectorAll('[data-rz-welcome-note]').forEach((n) => { n.hidden = false; n.textContent = (pill && pill.textContent.trim()) || code; });

  // 1 · apply quietly, once per browser session (Shopify keeps it on the cart and at checkout)
  function apply() {
    if (sessionStorage.getItem('rz-welcome-applied') === code) return Promise.resolve();
    return fetch(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart.js')}`, { credentials: 'same-origin' })
      .then(() => { try { sessionStorage.setItem('rz-welcome-applied', code); } catch (e) {} })
      .catch(() => {});
  }
  apply().then(() => { if (state.seen) note(); });

  // 2 · the sealed note
  function show() {
    if (state.seen) { if (pill) pill.hidden = false; return; }
    box.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => box.classList.add('is-in')));
  }
  function open() {
    box.classList.add('is-open');
    state.seen = 1; save(); note();
  }
  function close() {
    box.classList.remove('is-in');
    state.seen = 1; save(); note();
    setTimeout(() => { box.hidden = true; if (pill) { pill.hidden = false; requestAnimationFrame(() => pill.classList.add('is-in')); } }, 700);
  }
  box.addEventListener('click', (e) => {
    if (e.target.closest('[data-rz-welcome-open]')) open();
    else if (e.target.closest('[data-rz-welcome-close]')) close();
  });
  if (pill) pill.addEventListener('click', () => { const c = document.querySelector('cart-drawer'); if (c && c.open) c.open(); });
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && box.classList.contains('is-in')) close(); });

  // appear once the intro has finished and the visitor has had a moment with the page. The note and
  // pill sit over the hero's shop button, so on the homepage they wait until the visitor scrolls past it.
  const delay = (parseFloat(box.dataset.delay) || 5) * 1000;
  const cta = document.querySelector('.rz-ap-cta');
  const covers = () => cta && scrollY < innerHeight * 0.4;
  function showClear() {
    if (cta && pill) addEventListener('scroll', () => { if (!pill.hidden) pill.classList.toggle('is-tucked', covers()); }, { passive: true });
    if (!covers()) return show();
    const go = () => { if (!covers()) { removeEventListener('scroll', go); show(); } };
    addEventListener('scroll', go, { passive: true });
  }
  const wait = () => (html.classList.contains('rz-intro-on') ? setTimeout(wait, 400) : setTimeout(showClear, delay));
  wait();
  document.addEventListener('rz:cart-rendered', () => { if (state.seen) note(); });
})();
